// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5911":"54d05213","9724":"0081a2fd"}[chunkId] + ".js";
};